import { StyleSheet, Platform, ViewStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { CONTENT_MAX_WIDTH } from "../../../shared/config";
import { HEADER_HEIGHT } from "../header/Header.style";

const style = () => {
  const {
    colorBgBase,
    colorBgPrimaryLight,
    space6,
    space16,
    space2,
    space3,
    space4,
    space8,
    space12,
    borderRadius3,
    borderRadius4,
    colorTextMedium,
  } = theme();

  return StyleSheet.create({
    banner: {
      justifyContent: "center",
      padding: space3,
    },
    buyNowGetLooks: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      paddingHorizontal: space2,
      paddingVertical: space4,
    },
    buyNowGetLooksImage: {
      height: 63,
      marginRight: space2,
      width: 105,
    },
    buyNowGetLooksInfo: {
      flexShrink: 1,
    },
    buyNowGetLooksLarge: {
      borderBottomWidth: 1,
      borderColor: colorBgPrimaryLight,
    },
    buyNowGetLooksSmall: {
      borderColor: colorBgPrimaryLight,
      borderWidth: 1,
    },
    checkoutAddress: {
      backgroundColor: colorBgPrimaryLight,
      borderRadius: borderRadius3,
      padding: space6,
    },
    checkoutAddressDesktop: {
      marginBottom: space6,
    },
    checkoutAddressMobile: {
      marginBottom: space4,
    },
    checkoutTitle: {
      paddingBottom: space4,
      paddingTop: space4,
    },
    checkoutTitleDesktop: {
      marginBottom: space4,
    },
    checkoutTitleMobile: {
      textAlign: "center",
    },
    containerPriceDetail: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: space4,
    },
    contentWrapper: {
      maxWidth: CONTENT_MAX_WIDTH,
    },
    contentWrapperDesktop: {
      paddingBottom: space12,
      paddingTop: space12,
    },
    contentWrapperMobile: {
      backgroundColor: colorBgBase,
      padding: 0,
    },
    header: {
      height: HEADER_HEIGHT,
    },
    lastContainerPriceDetailMobile: {
      marginBottom: 0,
    },
    leftColumnDektop: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      flex: 1,
      marginRight: space16,
      padding: space6,
    },
    leftColumnMobile: {
      paddingBottom: space6,
      paddingHorizontal: space6,
      paddingTop: space4,
    },
    paymentInstrumentDesktop: {
      marginBottom: space6,
    },
    paymentInstrumentMobile: {
      marginBottom: space4,
    },
    productList: {
      padding: 0,
    },
    promoInfo: {
      color: colorTextMedium,
      marginBottom: space6,
    },
    promocodeWrapperDesktop: {
      marginBottom: space4,
    },
    promocodeWrapperMobile: {
      marginBottom: space8,
    },
    rightColumn: {
      padding: space6,
    },
    rightColumnDesktop: {
      borderRadius: borderRadius4,
      backgroundColor: colorBgBase,
      ...Platform.select({
        web: {
          top: 112,
          position: "sticky",
        },
      }),
    } as ViewStyle,
    rightColumnMobile: {
      backgroundColor: colorBgPrimaryLight,
    },
    scrollView: {
      backgroundColor: colorBgPrimaryLight,
      flex: 1,
    },
    spinnerWrapper: {
      alignItems: "center",
      backgroundColor: colorBgBase,
      flex: 1,
      justifyContent: "center",
    },
  });
};

export { style };
